

<template>
  <ChatBotButton @click="goToChatBot"/>
    <!-- Vuetify footer component -->
    <v-footer class="d-flex flex-column" absolute>
      <div class="px-4 py-2 text-white text-center w-100 aqua-teal pure-white">
        © 2025 MEND™. All rights reserved. | Terms of Use | Privacy Policy
      </div>
    </v-footer>
</template>

<script>
import ChatBotButton from "./ChatBotButton.vue";
export default {
    // Properties returned from data() become reactive state
    // and will be exposed on `this`.
    name: 'MENDFooter',
    components:{
      ChatBotButton
    },
    methods: {
      goToChatBot(){
        this.$router.push({name: "ChatBot"})
      }
    }
  };
    
</script> 

<style scoped>
* {
  font-family: 'Montserrat';
}
.aqua-teal {
    background-color: #08B6AA;
}

.pure-white {
  color: #ffffff;
}
</style>
